interface OnboardBgWrapperProps {
  children: React.ReactNode;
}

const OnboardBgWrapper = ({ children }: OnboardBgWrapperProps) => (
  <div className="relative min-h-[calc(100vh-var(--workspace-header-height,2.75rem))] bg-[var(--inv-bg,#f5f2ed)]">
    <div className="relative z-[1]">{children}</div>
  </div>
);

export default OnboardBgWrapper;
